import { colors, fonts } from '@grupoboticario/flora-tokens/dist/fidelidadeBelezaNaWeb/web/ds'

export const fidelidadeBelezaNaWeb = {
  colors,
  fonts,
}
